import React from "react";
import "./MoreServices.css";
import { motion } from "framer-motion";
import itmsImg from "../../assets/itms.jpg"; // add your image
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward, faForward } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Itms() {
  const leftVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  };

  return (
    <>
      <h2 className="ecommerce-heading">
        Integrated Traffic Management System
      </h2>

      <div className="service-container" id="top">
        <div className="service-data-container">

          {/* IMAGE */}
          <div className="image-container">
            <p className="hover-text">
              Integrated systems that combine monitoring, automation, and data management into one unified platform.
            </p>
            <img className="img-moredetails" src={itmsImg} alt="ITMS" />
          </div>

          {/* CONTENT */}
          <div className="content-section">
           <motion.h2
  className="fw-bold"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.1 }}
  variants={leftVariants}
>
  Integrated Traffic Management System (ITMS)
</motion.h2>

<motion.p className="text-body-secondary" variants={leftVariants}>
  Growbean’s Integrated Traffic Management System (ITMS) is designed to integrate multiple systems
  into a single platform, enabling seamless monitoring, automation, and efficient system operations.
  It helps in managing data, improving coordination, and supporting intelligent decision-making across various use cases.
</motion.p>

<br />

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">1. Integrated Platform:</span>{" "}
  Combines multiple systems and technologies into one unified platform,
  ensuring smooth communication and streamlined operations.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">2. Real-time Monitoring:</span>{" "}
  Enables continuous monitoring of all connected systems and activities,
  providing complete visibility and better control.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">3. Data Management:</span>{" "}
  Collects, processes, and manages data efficiently,
  allowing better analysis, reporting, and system optimization.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">4. Automation Support:</span>{" "}
  Supports automation of workflows and system processes,
  reducing manual effort and improving operational efficiency.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">5. Vehicle Classification:</span>{" "}
  Classifies vehicles into categories such as cars, trucks, buses, and two-wheelers,
  enabling structured data and better analysis.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">6. Vehicle Detection:</span>{" "}
  Detects and tracks vehicle presence and movement in real-time,
  supporting monitoring, automation, and system operations.
</motion.p>
          </div>
        </div>
      </div>

      {/* NAVIGATION */}
      <div className="d-flex justify-content-around m-5">
        <Link to="/atms">
          <button className="bn53">
            <FontAwesomeIcon icon={faBackward} /> Prev
          </button>
        </Link>
        <Link to="/services">
          <button className="bn53">
            Next <FontAwesomeIcon icon={faForward} />
          </button>
        </Link>
      </div>
    </>
  );
}

export default Itms;